import { CartUpdateEvent } from '@theme/events';

const CART_SYNC_SOURCE = 'trp-history-cart-sync';

function getNavigationType() {
  if (!performance.getEntriesByType) return '';

  const navigation = performance.getEntriesByType('navigation')[0];
  return navigation ? navigation.type : '';
}

function shouldSyncCart(event) {
  return Boolean(event.persisted || getNavigationType() === 'back_forward');
}

function getCartJsonUrl() {
  const theme = typeof Theme !== 'undefined' ? Theme : window.Theme;
  const cartUrl = theme?.routes?.cart_url || '/cart';
  const normalizedCartUrl = cartUrl.endsWith('/') ? cartUrl.slice(0, -1) : cartUrl;

  return `${normalizedCartUrl}.js`;
}

async function syncCartState() {
  const response = await fetch(getCartJsonUrl(), {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Cart sync failed with status ${response.status}`);
  }

  const cart = await response.json();
  const itemCount = Number(cart?.item_count) || 0;

  try {
    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(itemCount),
        timestamp: Date.now(),
      })
    );
  } catch (_) {
    // sessionStorage can be unavailable in strict privacy contexts.
  }

  document.dispatchEvent(
    new CartUpdateEvent(cart, CART_SYNC_SOURCE, {
      itemCount,
      source: CART_SYNC_SOURCE,
    })
  );
}

window.addEventListener('pageshow', (event) => {
  if (!shouldSyncCart(event)) return;

  window.requestAnimationFrame(() => {
    syncCartState().catch((error) => {
      console.warn('[TRP] Unable to resync cart after browser history restore.', error);
    });
  });
});
